<script lang="ts">
	import { ActionsContainer, IconButton, CircleAvatar } from '@Shelly/shelly-design-system/index';
	import type { AvatarColorVariantTypes } from '@Shelly/shelly-design-system/index';
	import { createEventDispatcher, onMount } from 'svelte';
	import type { SubUnitData } from './interfaces/SubUnit';
	import { format } from 'svelte-i18n';
	import { checkIfColorIsAvatarVariant } from 'src/helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { advancedCardComponent } from 'src/stores/advanced_card';

	const dispatch = createEventDispatcher<{
		renew: void;
		edit: void;
		remove: void;
	}>();

	export let subUnit: SubUnitData;

	let hasAvatar = false;

	onMount(() => {
		setAvatar();
	});

	function setAvatar(): void {
		if (subUnit[0].avatar?.includes('https://')) {
			hasAvatar = true;
		}

		if (subUnit[0].avatar === undefined) {
			subUnit[0].avatar = 'color-green';
		}
	}

	function getBackgroundColor(color: string | undefined): AvatarColorVariantTypes | null {
		if (!color || !checkIfColorIsAvatarVariant(color)) {
			return null;
		}

		return color as AvatarColorVariantTypes;
	}
</script>

<svelte:component
	this={$advancedCardComponent}
	title={subUnit[0].name}
	subtitle={{ value: subUnit[0].email, bold: false, textSmall: true }}
>
	<CircleAvatar
		slot="left"
		class="cursor-pointer pt-xs pb-xs pl-s"
		size="m"
		image={hasAvatar ? subUnit[0].avatar : null}
		text={subUnit[0].name[0].toUpperCase()}
		backgroundColor={hasAvatar ? null : getBackgroundColor(subUnit[0].avatar)}
		borderStatus={{ color: 'color-white' }}
	/>
	<ActionsContainer type="simple" slot="right">
		<IconButton
			aria-label={$format('button_edit', { default: 'Edit' })}
			icon="fas fa-pen"
			variant={$showNewLayout ? 'help-2' : 'primary'}
			slot="second"
			on:click={() => dispatch('edit')}
		/>
		<IconButton
			aria-label={$format('button_delete', { default: 'Delete' })}
			icon="fas fa-trash"
			variant={$showNewLayout ? 'help-2' : 'danger'}
			slot="third"
			on:click={() => dispatch('remove')}
		/>
	</ActionsContainer>
</svelte:component>
